import { $axios } from './config';

const url = '';

/**
 *
 * @param {*} payload { username: string, password: string }
 * @returns
 */
export const loginUser = async (payload) => {
    return $axios.post(`${url}/User/login`, payload);
};

export const LoginLight = async (payload) => {
    return $axios.post(`${url}/User/LoginLight`, payload);
};

/**
 *
 * @param {*} payload { userId: string, token: string }
 * @returns
 */
export const authRSA = async (payload) => {
    return $axios.post(`${url}/AuthRSA`, payload);
};

/**
 *
 * @param {*} payload { accessToken: string, refreshToken: string }
 * @returns
 */
export const refreshAuth = async (payload) => {
    return $axios.post(`${url}/refresh`, payload);
};
